import { AnimatePresence, motion } from 'framer-motion'
import type { SyncSaveState } from '@/types'
import { toastReducedVariants, toastVariants, usePrefersReducedMotion } from '@/design-system/motion'
import { Button } from './Button'
import { SyncStatus } from './SyncStatus'
import './SaveBar.css'

export type SaveBarProps = {
  visible: boolean
  saving?: boolean
  saveLabel?: string
  onSave: () => void
  onCancel?: () => void
  /** Truthy value renders the canonical SyncStatus next to the actions. */
  state?: SyncSaveState | null
}

/** Sticky bottom save footer for long forms (spec §6.9). */
export function SaveBar({ visible, saving = false, saveLabel = 'Opslaan', onSave, onCancel, state }: SaveBarProps) {
  const reducedMotion = usePrefersReducedMotion()
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="ui-savebar"
          role="region"
          aria-label="Wijzigingen opslaan"
          variants={reducedMotion ? toastReducedVariants : toastVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <div className="ui-savebar__status">{state ? <SyncStatus state={state} /> : null}</div>
          <div className="ui-savebar__actions">
            {onCancel && (
              <Button variant="ghost" onClick={onCancel} disabled={saving}>
                Annuleren
              </Button>
            )}
            <Button variant="primary" onClick={onSave} loading={saving}>
              {saveLabel}
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
